module.exports = __webpack_public_path__ + "img/cashier-icon-03.6340a377.png";